module.exports = __webpack_public_path__ + "media/images/flf-flower_full-4ae4cd26fc5c955b97949c2f5be64dd3.jpg";